import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon-truck-stop",
  "use": "icon-icon-truck-stop-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-icon-truck-stop\"><circle cx=\"12\" cy=\"12\" r=\"12\" fill=\"#fff\" /><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12A12 12 0 0 0 12 0Zm0 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10ZM10.57 8.68H7.44V6.36h9.13v2.32h-3.13v9h-2.87v-9Z\" fill=\"#ED593B\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol